const Resources = {
    table_headers: [
        { 
          text: 'Name',  
          align: 'start', 
          value: 'name'
        },
        { 
          text: 'Abbreviation',
          value: 'abbreviation'
        },
        { 
            text: 'Type',           
            value: 'type' 
        },
        { 
            text: 'Zip code',       
            value: 'zip_code' 
        },
        {   
            text: 'Email',          
            value: 'email' 
        },
        {   
            text: 'Phone',          
            value: 'phone' 
        },
        { 
            text: 'Country',        
            value: 'country' 
        },
        { 
            text: 'State',          
            value: 'state' 
        },
    ],

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Facilities',
            href:   '/facility',
            arrow:  " ",
        },
    ],
}

export default Resources